import { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import Hero from "./components/landing/Hero";
import Marquee from "./components/landing/Marquee";
import Problem from "./components/landing/Problem";
import ProductIntro from "./components/landing/ProductIntro";
import WhatsInside from "./components/landing/WhatsInside";
import WhoFor from "./components/landing/WhoFor";
import BigIdea from "./components/landing/BigIdea";
import Offer from "./components/landing/Offer";
import WhatsAppLead from "./components/landing/WhatsAppLead";
import Creator from "./components/landing/Creator";
import Faq from "./components/landing/Faq";
import FinalCta from "./components/landing/FinalCta";
import Footer from "./components/landing/Footer";
import StickyCta from "./components/landing/StickyCta";
import CheckoutModal from "./components/landing/CheckoutModal";
import FloatingWhatsApp from "./components/landing/FloatingWhatsApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
                    <p className="font-serif text-2xl text-plum">Something went wrong. Please refresh the page.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <main className="relative overflow-x-clip bg-cream" data-testid="landing-page">
                                <Hero />
                                <Marquee />
                                <Problem />
                                <ProductIntro />
                                <WhatsInside />
                                <WhoFor />
                                <BigIdea />
                                <WhatsAppLead />
                                <Offer />
                                <Creator />
                                <Faq />
                                <FinalCta />
                                <Footer />
                                <StickyCta />
                                <CheckoutModal />
                            </main>
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <main className="relative overflow-x-clip bg-cream" data-testid="landing-page">
                                <Hero />
                                <Marquee />
                                <Problem />
                                <ProductIntro />
                                <WhatsInside />
                                <WhoFor />
                                <BigIdea />
                                <WhatsAppLead />
                                <Offer />
                                <Creator />
                                <Faq />
                                <FinalCta />
                                <Footer />
                                <StickyCta />
                                <CheckoutModal />
                            </main>
                        }
                    />
                </Routes>
                <FloatingWhatsApp />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
